// src/components/blogs/BlogList.jsx
import React from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import BlogListItem from './BlogListItem'

const BlogList = ({ allData, viewDetails, editBlog, deleteBlog }) => {
    return (
        <div className="table-responsive">
            <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                <thead>
                    <tr className="fw-bold">
                        <th className="w-25px">
                            <div className="form-check form-check-sm form-check-custom form-check-solid">
                                <input
                                    className="form-check-input"
                                    disabled
                                    type="checkbox"
                                    value="1"
                                    data-kt-check="true"
                                    data-kt-check-target=".widget-9-check"
                                />
                            </div>
                        </th>
                        <th className="min-w-150px">Blog Title</th>
                        <th className="min-w-150px">Meta Title</th>
                        <th className="min-w-150px">Keywords</th>
                        <th className="min-w-150px">Status</th>
                        <th className="min-w-50px">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {allData.map((item) => (
                        <BlogListItem
                            key={item._id}
                            item={item}
                            viewDetails={viewDetails}
                            editBlog={editBlog}
                            deleteBlog={deleteBlog}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default BlogList
